import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { Product3dViewComponent } from './product-3d-view.component';
export var Product3dViewComponentNgModule = module(baseModuleId + ".product-3d-view", [])
    .component('product3dView', Product3dViewComponent);
